import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { CAUSES_PERMISSION_CODES } from 'permissions/constants/causesPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { CAUSES_PERMISSION_CODES };

const usePermissionsCauses = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.CASES),
      canViewSection: hasPermission(CAUSES_PERMISSION_CODES.VIEW_SECTION),
      canCreate: hasPermission(CAUSES_PERMISSION_CODES.CREATE),
      canDownloadExcel: hasPermission(CAUSES_PERMISSION_CODES.DOWNLOAD_EXCEL),
      canViewDetail: hasPermission(CAUSES_PERMISSION_CODES.VIEW_DETAIL),
      canViewBlockedClientCause: hasPermission(
        CAUSES_PERMISSION_CODES.VIEW_BLOCKED_CLIENT_CAUSE
      ),
      canAccessDetail: hasPermission(CAUSES_PERMISSION_CODES.DETAIL),
      canViewDetailSection: hasPermission(
        CAUSES_PERMISSION_CODES.DETAIL_VIEW_SECTION
      ),
      canEdit: hasPermission(CAUSES_PERMISSION_CODES.EDIT),
      canViewClient: hasPermission(CAUSES_PERMISSION_CODES.VIEW_CLIENT),
      canAddUser: hasPermission(CAUSES_PERMISSION_CODES.ADD_USER),
      canRemoveUser: hasPermission(CAUSES_PERMISSION_CODES.REMOVE_USER),
      canViewLegacyMovements: hasPermission(
        CAUSES_PERMISSION_CODES.LEGACY_MOVEMENTS
      ),
      canAccessMovements: hasPermission(CAUSES_PERMISSION_CODES.MOVEMENTS),
      canViewMovementsSection: hasPermission(
        CAUSES_PERMISSION_CODES.MOVEMENTS_VIEW_SECTION
      ),
      canViewDocument: hasPermission(CAUSES_PERMISSION_CODES.VIEW_DOCUMENT),
      canManageMovements: hasPermission(
        CAUSES_PERMISSION_CODES.MANAGE_MOVEMENTS
      ),
      canAccessTasks: hasPermission(CAUSES_PERMISSION_CODES.TASKS),
      canViewTasksSection: hasPermission(
        CAUSES_PERMISSION_CODES.TASKS_VIEW_SECTION
      ),
      canCreateTask: hasPermission(CAUSES_PERMISSION_CODES.CREATE_TASK),
      canManageTask: hasPermission(CAUSES_PERMISSION_CODES.MANAGE_TASK),
      canEditTask: hasPermission(CAUSES_PERMISSION_CODES.EDIT_TASK),
      canPublishComment: hasPermission(CAUSES_PERMISSION_CODES.PUBLISH_COMMENT),
      canAttachFile: hasPermission(CAUSES_PERMISSION_CODES.ATTACH_FILE),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsCauses;
